export default __webpack_public_path__ + "static/media/slider.6de2bbfa.less";